import React from "react";
import { Plus, X } from "lucide-react";

export default function GroupHomeView({
  group,
  backLabel,
  closeLabel,
  description,
  coverImageUrl,
  coverImageAlt,
  coverObjectPosition,
  coverScale = 1,
  coverInteractive = false,
  headerBadges,
  stats,
  actions,
  invitePanel,
  postToggleLabel,
  feedTitle,
  feedSubtitle,
  composer,
  feedContent,
  onBack,
  onCoverClick,
  onToggleComposer,
}) {
  if (!group) return null;

  return (
    <div className="groups-home-shell">
      <div className="groups-home-header-card">
        <button
          type="button"
          className="groups-home-close-btn"
          onClick={onBack}
          aria-label={closeLabel || backLabel}
        >
          <X size={18} strokeWidth={2.5} aria-hidden="true" />
        </button>

        <div className="groups-home-header-top">
          <div className="groups-home-header-actions">
            <div className="groups-home-actions">
              {actions}
              <button
                type="button"
                className="groups-primary-btn groups-home-create-toggle"
                onClick={onToggleComposer}
              >
                <Plus size={16} strokeWidth={2.4} aria-hidden="true" />
                {postToggleLabel}
              </button>
            </div>
          </div>
        </div>

        {coverImageUrl ? (
          coverInteractive ? (
            <button
              type="button"
              className="groups-home-cover-button"
              onClick={onCoverClick}
            >
              <img
                src={coverImageUrl}
                alt={coverImageAlt || group.name}
                className="groups-home-cover"
                style={{
                  objectPosition: coverObjectPosition,
                  transform: `scale(${coverScale})`,
                }}
              />
            </button>
          ) : (
            <div className="groups-home-cover-wrap">
              <img
                src={coverImageUrl}
                alt={coverImageAlt || group.name}
                className="groups-home-cover"
                style={{
                  objectPosition: coverObjectPosition,
                  transform: `scale(${coverScale})`,
                }}
              />
            </div>
          )
        ) : null}

        <div className="groups-card-tags">
          {headerBadges}
        </div>

        <h2 className="groups-home-title">{group.name}</h2>
        <p className="groups-home-description">{description}</p>

        <div className="groups-detail-stats">
          {stats}
        </div>

        {invitePanel}
      </div>

      {composer}

      <div className="groups-feed-card">
        <div className="groups-feed-header">
          <div>
            <h3>{feedTitle}</h3>
            <p className="groups-feed-subtitle">{feedSubtitle}</p>
          </div>
        </div>

        {feedContent}
      </div>
    </div>
  );
}
